import Global from '../../../../store/global-selectors';
import { WeightUnit } from '../../../../enums/weight-unit';

export const BULK_UPDATE_WEIGHT_ID = 'bulk-update-weight';

export const bulkUpdateWeightCapability = {
  id: BULK_UPDATE_WEIGHT_ID,
  getAdditionalContext: (reduxState) => {
    const selectedOrderCount = Global.selectSelectedOrdersCount(reduxState);
    const sellerWeightUnit = Global.selectSellerDefaultWeightUnit(reduxState);

    return {
      availableWeightUnits:
        sellerWeightUnit === WeightUnit.Ounces ? [WeightUnit.Pounds, WeightUnit.Ounces] : [WeightUnit.Kilograms, WeightUnit.Grams],
      availableWeightModes: [
        { id: 'set-weight', description: 'Replace existing weight with new value' },
        { id: 'add-weight', description: 'Add to current weight' },
      ],
      selectedOrderCount,
    };
  },
};
